/**
 * Created by Administrador on 18/05/2018.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('clientService', clientService);

    clientService.$inject = ['$http', 'CONFIG', 'messageService'];

    function clientService($http, CONFIG, messageService){
        var urlBase = CONFIG.API_OAUTH+'/api';
        /*if(CONFIG.SERVER === 'server'){
            urlBase = 'http://172.16.0.103:9999/uaa/api';
        }*/

        var service = {
            getAllApplicationList: getAllApplicationList,
            getAllApplicationPage: getAllApplicationPage,
            getAllApplicationUiTrue: getAllApplicationUiTrue,
            getAllOauthClient: getAllOauthClient,
            saveOauthClient: saveOauthClient,
            updateOauthClient: updateOauthClient
        }

        return service;

        function getAllApplicationList(){
            return $http.get(urlBase+'/applicationClient/all')
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getAllApplicationPage(page, size){
            return $http.get(urlBase + '/applicationClient/allPage?page=' + page + '&size=' + size)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getAllApplicationUiTrue(){
            return $http.get(urlBase+'/applicationClient/ui-true')
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getAllOauthClient(clientId){
            return $http.get(urlBase+'/oauthClient/'+clientId)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function saveOauthClient(client){
            return $http.post(urlBase+'/oauthClient', client)
                .then(function(response){
                    messageService.register('clients');
                    return true;
                })
                .catch(function(error){
                    messageService.registerError('clients');
                    return false;
                });
        }

        function updateOauthClient(client, clientId){
            return $http.put(urlBase + "/oauthClient/" + clientId, client)
                .then(function(response){
                    messageService.registerUpdate('clients');
                    return response;
                })
                .catch(function(){
                    messageService.registerUpdateError('clients')
                });
        }
    }
})();
